import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { PermissionsGroupModel as Model } from './Model'


export const MODULE_NAME = 'groups'

export const GROUPS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: GROUPS_ROUTES.LAYOUT,
  route: { name: GROUPS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-multiple-plus-outline',
} as const

export const createPermissionsGroupsCopyAteModal = (
  parent: unknown,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PermissionsGroupsCopyAteModal" */
    './components/PermissionsGroupsCopyAteModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
